"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.array.for-each");

var _classCallCheck = require("/home/runner/work/www.pedrocsilva.com/www.pedrocsilva.com/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/www.pedrocsilva.com/www.pedrocsilva.com/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/runner/work/www.pedrocsilva.com/www.pedrocsilva.com/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/www.pedrocsilva.com/www.pedrocsilva.com/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/www.pedrocsilva.com/www.pedrocsilva.com/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

require("core-js/modules/es6.object.define-property");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bouncer = void 0;

var Utils_1 = require("../../../Utils");

var Enums_1 = require("../../../Enums");

var Vector_1 = require("../../../Core/Particle/Vector");

var ExternalInteractorBase_1 = require("../../../Core/ExternalInteractorBase");

var Bouncer = /*#__PURE__*/function (_ExternalInteractorBa) {
  _inherits(Bouncer, _ExternalInteractorBa);

  var _super = _createSuper(Bouncer);

  function Bouncer(container) {
    _classCallCheck(this, Bouncer);

    return _super.call(this, container);
  }

  _createClass(Bouncer, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container,
          options = container.actualOptions,
          mouse = container.interactivity.mouse,
          events = options.interactivity.events,
          divs = events.onDiv;
      return mouse.position && events.onHover.enable && (0, Utils_1.isInArray)(Enums_1.HoverMode.bounce, events.onHover.mode) || (0, Utils_1.isDivModeEnabled)(Enums_1.DivMode.bounce, divs);
    }
  }, {
    key: "interact",
    value: function interact() {
      var _this = this;

      var container = this.container,
          options = container.actualOptions,
          events = options.interactivity.events,
          mouseMoveStatus = container.interactivity.status === Utils_1.Constants.mouseMoveEvent,
          hoverEnabled = events.onHover.enable,
          hoverMode = events.onHover.mode,
          divs = events.onDiv;

      if (mouseMoveStatus && hoverEnabled && (0, Utils_1.isInArray)(Enums_1.HoverMode.bounce, hoverMode)) {
        this.processMouseBounce();
      } else {
        (0, Utils_1.divModeExecute)(Enums_1.DivMode.bounce, divs, function (selector, div) {
          return _this.singleSelectorBounce(selector, div);
        });
      }
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "processMouseBounce",
    value: function processMouseBounce() {
      var container = this.container,
          pxRatio = container.retina.pixelRatio,
          tolerance = 10 * pxRatio,
          mousePos = container.interactivity.mouse.position,
          radius = container.retina.bounceModeDistance;

      if (mousePos) {
        this.processBounce(mousePos, radius, new Utils_1.Circle(mousePos.x, mousePos.y, radius + tolerance));
      }
    }
  }, {
    key: "singleSelectorBounce",
    value: function singleSelectorBounce(selector, div) {
      var _this2 = this;

      var container = this.container;
      var query = document.querySelectorAll(selector);

      if (!query.length) {
        return;
      }

      query.forEach(function (item) {
        var elem = item,
            pxRatio = container.retina.pixelRatio,
            pos = {
          x: (elem.offsetLeft + elem.offsetWidth / 2) * pxRatio,
          y: (elem.offsetTop + elem.offsetHeight / 2) * pxRatio
        },
            radius = elem.offsetWidth / 2 * pxRatio,
            tolerance = 10 * pxRatio;
        var area = div.type === Enums_1.DivType.circle ? new Utils_1.Circle(pos.x, pos.y, radius + tolerance) : new Utils_1.Rectangle(elem.offsetLeft * pxRatio - tolerance, elem.offsetTop * pxRatio - tolerance, elem.offsetWidth * pxRatio + tolerance * 2, elem.offsetHeight * pxRatio + tolerance * 2);

        _this2.processBounce(pos, radius, area);
      });
    }
  }, {
    key: "processBounce",
    value: function processBounce(position, radius, area) {
      var query = this.container.particles.quadTree.query(area);

      var _iterator = _createForOfIteratorHelper(query),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var particle = _step.value;

          if (area instanceof Utils_1.Circle) {
            (0, Utils_1.circleBounce)((0, Utils_1.circleBounceDataFromParticle)(particle), {
              position: position,
              radius: radius,
              mass: Math.pow(radius, 2) * Math.PI / 2,
              velocity: Vector_1.Vector.origin,
              factor: Vector_1.Vector.origin
            });
          } else if (area instanceof Utils_1.Rectangle) {
            (0, Utils_1.rectBounce)(particle, (0, Utils_1.calculateBounds)(position, radius));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return Bouncer;
}(ExternalInteractorBase_1.ExternalInteractorBase);

exports.Bouncer = Bouncer;